import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import LoadingData from "../../Common/LoadingData";



const AllStories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // setLoading(false);
    fetch(`${process.env.REACT_APP_BASE_URL}/reads`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const bbb = data.msg.map((b, index) => b.reads);
        let arr = [];
        bbb.map((v, index) => arr.push(...v));
        setData(arr);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDelete = (id) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/read/${id}`, {
      method: "DELETE",
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        if (res.status === "success") {
          setData(data.filter((item) => item._id !== id));
        } else {
          alert(res.msg);
        }
      });
  };

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : (
    <div className="add-page">
      <table>
        <caption>All Stories</caption>
        <thead>
          <tr>
            <th>Title</th>
            <th>Level</th>
            <th>Membership</th>
            <th>Delete</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item?.title}</td>
              <td>{item?.level}</td>
              <td>{item?.membership}</td>
              <td>
                <span className="delete" onClick={() => handleDelete(item._id)}>
                  <AiFillDelete />
                </span>
              </td>
              <td>
                <Link to={`/dashboard/edit-story/${item._id}`}>
                  <span className="edit">
                    <FaEdit />
                  </span>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllStories;
